// services/navigationUtil.js
let navigateInstance = null;

export const setGlobalNavigate = (nav) => {
  navigateInstance = nav;
};

export const globalNavigate = (path) => {
  if (navigateInstance) {
    navigateInstance(path);
  } else {
    // Fallback to window location if the app hasn't mounted yet
    window.location.href = path;
  }
};